import { useCallback } from 'react';

import { loginCRM, updateAmplitudeUserAttributes, updateAmplitudeUserId } from 'state/amplitude';
import { logoutBranch, setBranchIdentity } from 'state/branch/utils';
import { useBrazeContext } from 'state/braze';
import { useExperiments } from 'state/experiments';
import {
  logoutLaunchDarklyUser,
  updateLaunchDarklyUser,
} from 'state/launchdarkly/launchdarkly-core';
import { getName } from 'utils/attributes';
import Braze from 'utils/braze';
import { getCrashlytics, setUserId } from 'utils/crashlytics';

import { UserDetails } from './types';

export const useThirdPartyAuthentication = () => {
  const { setUserId: brazeSetUserId } = useBrazeContext();
  const {
    handleLogin: handleExperimentsLogin,
    handleLogout: handleExperimentsLogout,
  } = useExperiments();

  const logUserInToThirdPartyServices = useCallback(
    (currentUser: UserDetails) => {
      const { cognitoId, thLegacyCognitoId, details } = currentUser;
      const { name, email } = details;

      updateLaunchDarklyUser(
        {
          ...getName({ name }, { firstName: '', lastName: '' }),
          key: cognitoId,
          name,
          email,
          anonymous: false,
        },
        'third party authentication'
      );

      loginCRM({
        customerid: cognitoId,
        rbiCognitoId: cognitoId,
        ...details,
      });

      brazeSetUserId(thLegacyCognitoId ? `us-east-1:${thLegacyCognitoId}` : cognitoId);

      setBranchIdentity(cognitoId);

      updateAmplitudeUserAttributes(details);

      handleExperimentsLogin(cognitoId);

      // Update Braze Email for the user
      Braze.setEmail(details.email);

      setUserId(getCrashlytics(), cognitoId);
    },
    [brazeSetUserId, handleExperimentsLogin]
  );

  const logUserOutOfThirdPartyServices = useCallback(() => {
    logoutLaunchDarklyUser();
    updateAmplitudeUserId(null);
    brazeSetUserId(null);
    logoutBranch();
    handleExperimentsLogout();
    setUserId(getCrashlytics(), '');
  }, [brazeSetUserId, handleExperimentsLogout]);

  return { logUserInToThirdPartyServices, logUserOutOfThirdPartyServices };
};
